export default __webpack_public_path__ + "static/media/takhtejamshid.01394acc.jpg";